export enum AccountKind {
    ROOT = 0,
    CLIENT = 1,
    TRIAL = 2
}
